export const SET_LOOKUPS = 'SET_LOOKUPS'
export const RESET_LOOKUPS = 'RESET_LOOKUPS'
export const SET_TIMEZONES = 'SET_TIMEZONES'
export const UPSERT_LOOKUP = 'UPSERT_LOOKUP'
export const DELETE_LOOKUP = 'DELETE_LOOKUP'
export const SET_GROUPS = 'SET_GROUPS'
export const UPSERT_GROUP = 'UPSERT_GROUP'
export const SET_LOOKUPS_ZEUS = 'SET_LOOKUPS_ZEUS'
export const SET_INSURANCE_COMPANIES = 'SET_INSURANCE_COMPANIES'



// WEBPACK FOOTER //
// ./src/store/modules/lookups/types.js